<template>

  <data-tables
    :ref="localTableRef"
    :data="localData"
    :table-props="localTableProps"
    :pagination-props="localPaginationProps"
    :actions-def="localActionsDef"
    :col-not-row-click="localColNotRowClick"
    :action-col="localActionCol"
    :layout="localLayout"
    :filters="localFilters"
    :current-page.sync="localCurrentPage"
    :page-size="localPageSize"
    v-loading="localLoading"
    @sort-change="handleSortChange"
    @filter-change="handleFilterChange"
    @row-click="handleRowClick"
    @selection-change="handleSelectionChange"
    @current-page-change="handleCurrentPageChange"
    @current-change="handleCurrentChange">

    <!-- <div slot="empty" style="color: #90939">데이터가 없습니다.</div> -->

    <template v-for="(column, index) in localTableColumns">
      <template v-if="column.group">
        <!-- group 일 경우에는 label 정보만 필요하다 -->
        <el-table-column :label="column.label" :key="'group_' + index" header-align="center" label-class-name="stone-table-label">
          <stone-data-table-column v-for="(col, idx) in column.group"
            :prop="col"
            :sortable="localTableProps.sortable"
            :key="'row_' + index + '_' + idx">
          </stone-data-table-column>
        </el-table-column>
      </template>
      <template v-else>
        <stone-data-table-column
          :prop="column"
          :sortable="localTableProps.sortable"
          :key="'row_' + index">
        </stone-data-table-column>
      </template>
    </template>

  </data-tables>

</template>

<script>
import stoneDataTable from '@/modules/stone-data-table'
export default {
  mixins: [stoneDataTable]
}
</script>



// WEBPACK FOOTER //
// src/components/stone-data-table/stone-data-table.vue